export default "__VITE_ASSET__Cyz4Qd80__"